import { Info } from "lucide-react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

/**
 * Tells a guest member whose company they are a guest in. The member list does not say
 * whether the person is a guest or an employee in their other companies, so a link to
 * "your own cabinet" is not offered.
 */
export default function GuestCompanyBanner({ companyId }: { companyId: string }) {
  const { t } = useTranslation();
  // The slice is plain JS, so its state is not typed.
  const companyName = useSelector(
    (state: any): string | undefined =>
      state.companySelectReducer.companiesCollectionRaw.find(
        (company: { id: string }) => company.id === companyId
      )?.name
  );
  if (!companyName) return null;

  return (
    <div
      role="note"
      className="flex items-start gap-3 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-900"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" />
      <p>{t("cabinet_guest_banner", { company: companyName })}</p>
    </div>
  );
}
